function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#000",
  fillOpacity: 0.65,
  fillRule: "nonzero",
  d: "M9.688.25H2.843a.094.094 0 0 0-.094.094V1c0 .052.042.094.094.094h6.844A.094.094 0 0 0 9.78 1V.344A.094.094 0 0 0 9.687.25zm0 3.328H2.843a.094.094 0 0 0-.094.094v.656c0 .052.042.094.094.094h6.844a.094.094 0 0 0 .093-.094v-.656a.094.094 0 0 0-.094-.094zm0 3.328H2.843A.094.094 0 0 0 2.75 7v.656c0 .052.042.094.094.094h6.844a.094.094 0 0 0 .093-.094V7a.094.094 0 0 0-.094-.094zM.217.672a.656.656 0 1 0 1.313 0 .656.656 0 0 0-1.312 0zM.219 4a.656.656 0 1 0 1.313 0A.656.656 0 0 0 .22 4zm0 3.328a.656.656 0 1 0 1.313 0 .656.656 0 0 0-1.312 0z"
});

var SvgUnorderedList = function SvgUnorderedList(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 10,
    height: 8,
    viewBox: "0 0 10 8",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgUnorderedList, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/unordered-list.5e3cf7dd.svg";
export { ForwardRef as ReactComponent };